const state = {
  data: {}
};

// getters
const getters = {};

// actions
const actions = {
  shared_contacts(state, data) {}
};

// mutations
const mutations = {
  setData(state, data) {
    state.data = data;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
